import { Button, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { useClientsContext } from "../context";

interface ClientsUploadConfirmProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void;
}

/**
 * Confirm step before the bulk client upload (DEV-1177, Figma 6559-45684). Warns
 * that confirming emails all clients in the file and cannot be undone, then hands
 * off to the existing spreadsheet importer (step "import").
 */
export const ClientsUploadConfirm = ({ onClose, className, ...props }: ClientsUploadConfirmProps) => {
  const { setStep } = useClientsContext();

  return (
    <div className={clsx("relative", className)} {...props}>
      <div className="text-center sm:text-left">
        <Typography variant="title">Upload Client List</Typography>
        <div className="mt-3 flex flex-col gap-4 text-neutral-dark-gray">
          <Typography variant="paragraph">
            You&apos;re about to upload a bulk client list. Once confirmed, an email with login details and setup instructions will be
            automatically sent to all clients in this file.
          </Typography>
          <Typography variant="paragraph">
            This action cannot be undone. Please make sure your file is correct and up to date before proceeding.
          </Typography>
        </div>
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <Button variant="secondary" onClick={onClose} className="px-8">
          Cancel
        </Button>
        <Button variant="primary" onClick={() => setStep("import")} className="px-8">
          Confirm
        </Button>
      </div>
    </div>
  );
};
